import { Play } from "lucide-react";
import { FadeUp, Label } from "./Primitives";
import { VIDEOS } from "../data/content";

function VideoCard({ v, delay }) {
  return (
    <FadeUp delay={delay} className={`${v.span}`}>
      <a
        href="#videos"
        data-testid={`video-card-${v.id}`}
        className="group relative block h-[300px] md:h-[360px] w-full overflow-hidden border border-white/8 bg-[#0b0b0b]"
      >
        <img
          src={v.image}
          alt={v.title}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover opacity-70 grayscale transition-all duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-105 group-hover:opacity-90 group-hover:grayscale-0"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
        <div
          className="absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
          style={{
            boxShadow: "inset 0 0 120px rgba(225,20,20,0.35)",
          }}
        />

        {/* play button */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full border border-white/30 backdrop-blur-md bg-white/5 transition-all duration-500 group-hover:scale-110 group-hover:border-[var(--noir-crimson)] group-hover:bg-[var(--noir-crimson)]/20">
            <Play size={20} className="ml-0.5 fill-white text-white" />
          </div>
        </div>

        {/* top meta */}
        <div className="absolute top-5 left-5 right-5 flex items-center justify-between">
          <span className="font-mono-accent text-xs text-white/50">{v.index}</span>
          <span className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-white/70 border border-white/15 px-2 py-1 backdrop-blur-sm">
            {v.category}
          </span>
        </div>

        {/* bottom meta */}
        <div className="absolute bottom-5 left-5 right-5">
          <div className="mb-2 flex items-center gap-2">
            <span
              className="h-1.5 w-1.5 rounded-full"
              style={{ background: "var(--noir-crimson)" }}
            />
            <span className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-white/50">
              {v.duration}
            </span>
          </div>
          <h3 className="font-display text-2xl md:text-3xl leading-tight text-white">
            {v.title}
          </h3>
        </div>
      </a>
    </FadeUp>
  );
}

export default function FeaturedVideos() {
  return (
    <section
      id="videos"
      data-testid="featured-videos"
      className="relative mx-auto max-w-[1500px] px-6 md:px-10 py-24 md:py-36"
    >
      <FadeUp className="mb-14 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div>
          <Label>Featured — 04 Films</Label>
          <h2 className="mt-4 font-display text-5xl md:text-7xl leading-[0.9] tracking-tight">
            The <span className="text-crimson italic">Case</span> Files
          </h2>
        </div>
        <p className="max-w-sm text-white/50 text-sm md:text-base leading-relaxed">
          Cinematic investigations into the mind. Each film dissects a single
          mechanism of human behavior — no filler, no noise.
        </p>
      </FadeUp>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-6">
        {VIDEOS.map((v, i) => (
          <VideoCard key={v.id} v={v} delay={i * 0.08} />
        ))}
      </div>
    </section>
  );
}
